import { Box } from '@mui/material';
import React from 'react';

export const ClickableCell = ({ onClick, children }: { onClick: () => void; children: React.ReactNode }) => (
  <Box
    onClick={(e) => {
      onClick();
      e.stopPropagation();
    }}
    sx={{ cursor: 'pointer', alignSelf: 'stretch', width: '100%', height: '100%', display: 'flex', alignItems: 'center' }}
  >
    {children}
  </Box>
);
